<template>
  <div class="animated fadeIn">
    
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="getData"
          :total-data="totalRows"
          :loading="loadingPage"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="spkbForm"
          :redirect-detail="true"
          :custom-variable-id="'spkb_number'"
          :show-add-button="false"
          :search-by-delivery-date="true"
          caption="<i class='fa fa-align-justify'></i> Pengembalian Barang (Retur)"
          @byPass="byPass"
        ></global-table>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import { required } from "vuelidate/lib/validators";
//import globalTable from "../../templates/Table.vue";
import loading from "@/templates/Loading.vue";
import globalTable from "../../templates/TableNew.vue";
import * as moment from "moment";

export default {
  name: "product-return",
  components: {
    globalTable,
    ModelSelect,
    loading,
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      spkb: [],
      spkb_retur: [],
      spkbDetail: [],
      loadingPage: true,
      totalRows: "",
      spkbForm: interfaces.spkb,
      fields: [
        { key: "spkb_number", sortable: true },
        { key: "driver_name", label: "Nama Supir" },
        { key: "penanggung_jawab_faktur", label: "Penanggung Jawab Faktur" },
        { key: "total_price_plan", label: "Total Plan" },
        { key: "total_price_actual", label: "Total Aktual" },
        { key: "total_price_retur", label: "Total Retur" },
        { key: "delivery_date", label: "Tanggal Pengiriman" },
        {
          key: "action_retur",
          label: "Action",
          class: "text-center width-100",
        },
      ],
      show_dc: false,
      findVal: false,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function () {
      this.loadingPage = true;
      this.getData();
    },
    getData: function (ctx) {
      let response = axios.post("web/product/return-product/", ctx);
      return response
        .then((data) => {
          const items = data.data.data;
          this.totalRows = data.data.total_rows;
          this.loadingPage = false;
          this.editButton = data.data.edit_button;
          return items;
        })
        .catch((error) => {
          this.expired(error);
          this.loadingPage = false;
          return [];
        });
    },
    
    byPass: function (data) {
      // evt.preventDefault();
      if (confirm("Data return akan di set 0 semua, apakah anda yakin ?")) {
        this.loadingPage = true;

        this.axios
          .get("web/product/return-product/detail/" + data.spkb_number + "/")
          .then((response) => {
            let data = response.data.data;
            this.spkbDetail = data;
            data.forEach((value, index) => {
              this.spkb_retur.push({
                qty: 0,
                product_id: value.product_id,
                qty_plan: value.qty_plan,
                qty_actual: value.qty_actual,
                price_plan: parseInt(value.price_plan),
                qty_each_box: parseInt(value.qty_each_box),
                order_type: parseInt(value.order_type)
              });
              this.totalQty += parseInt(value.qty_plan);
            });
          })
          .catch((error) => {
            this.expired(error, "Error Messages");
          })
          .finally(() => {
            this.axios
              .put("web/product/adjust-retur-spkb/", {
                spkb_number: data.spkb_number,
                data: { order_detail: this.spkb_retur },
              })
              .then((response) => {
                if (response.data.status === 2000) {
                  this.showInfoNotification({
                    title: "Adjust Retur SPKB",
                    message: response.data.message,
                  });

                }
              })
              .catch((error) => {
                this.expired(error, "Error Messages");
              })
              .finally(() => {
                window.location.reload();
                this.loadingPage = false;
              });
          });
      }
    },

    editForm: function (a) {
      this.resetForm();
      this.spkbForm = a;
    },
    setFilterDate: function(r) {
      this.$emit("myTable.filter::start_date", moment(this.myDate.start).format("YYYY-MM-DD")); 
      this.$emit("myTable.filter::end_date", moment(this.myDate.end).format("YYYY-MM-DD"));
      console.log(this.$refs.myTable);
      this.init();
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>